import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RechercheReferentielComponent, ReferentielType, Result } from 'src/app/fragments/modal/recherche-referentiel/recherche-referentiel.component';
import { ModalService } from '../modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class RechercheReferentielsService {

  constructor(
    private _modalSrv: ModalService
  ) { }

  public async initRecherche(viewCntnrRef: ViewContainerRef, enableRefs?: Array<ReferentielType>): Promise<Result | undefined> {
    return new Promise<Result | undefined>((resolve) => {
      const modal = this._modalSrv.openModal<RechercheReferentielComponent>(
        viewCntnrRef,
        RechercheReferentielComponent
      ) as ComponentRef<RechercheReferentielComponent>;
      modal.instance.enableRefs = enableRefs;

      const sub = modal.instance.closeEmitter.subscribe(v => {
        sub.unsubscribe();
        modal.destroy();
        resolve(v);
      });
    });
  }
}
